module.exports = __webpack_public_path__ + "static/media/zfp-logo-white.70f3ee0c.png";